import React, { useContext, useEffect } from 'react';
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalBody,
  Box,
  Image,
  useDisclosure,
  useBreakpointValue
} from '@chakra-ui/react';
import { LanguajeContext } from '../App';

const ModalTurismo = ({ defaultOpen = true }) => {
  const { lang } = useContext(LanguajeContext);

  const { isOpen, onOpen, onClose } = useDisclosure();

  // Abrir modal al montar si defaultOpen es true
  useEffect(() => {
    if (defaultOpen) {
      onOpen();
    }
  }, [defaultOpen, onOpen]);

  // Seleccionar imagen según tamaño de pantalla
  const imageSrc = useBreakpointValue({
    base: lang
      ? '/img/pop-up-turismo-ingles-mobile.jpg'
      : '/img/pop-up-turismo-mobile.jpg',
    md: lang
      ? '/img/pop-up-turismo-ingles.jpg'
      : '/img/pop-up-turismo.jpg'
  });

  return (
    <Modal isOpen={isOpen} onClose={onClose} isCentered>
      <ModalOverlay />
      <ModalContent
        borderRadius="0px"
        background="transparent"
        width={{ base: '90%', md: '800px' }}
        maxWidth="95%"
        boxShadow="none"
      >
        <ModalBody p={0}>
          <Box cursor="pointer" onClick={onClose}>
            <Image
              src={imageSrc}
              alt="Callia Criolla"
              width="100%"
              height="auto"
            />
          </Box>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default ModalTurismo;
